import { getCurrentCountry } from './country';
function resolveBelgiumCulture(pathname) {
    var pathnameInLowerCase = pathname.toLowerCase();
    if (pathnameInLowerCase.startsWith('/fr') ||
        pathnameInLowerCase.startsWith('/fr-be')) {
        return 'fr-BE';
    }
    return 'nl-BE';
}
function resolveAmericanCulture(pathname) {
    var pathnameInLowerCase = pathname.toLowerCase();
    if (pathnameInLowerCase.startsWith('/es') ||
        pathnameInLowerCase.startsWith('/us/es') // support for vista.com
    ) {
        return 'es-US';
    }
    return 'en-US';
}
function resolveCanadianCulture(pathname) {
    var pathnameInLowerCase = pathname.toLowerCase();
    if (pathnameInLowerCase.startsWith('/fr') ||
        pathnameInLowerCase.startsWith('/ca/fr') // support for vista.com
    ) {
        return 'fr-CA';
    }
    return 'en-CA';
}
function resolveSwissCulture(pathname) {
    var pathnameInLowerCase = pathname.toLowerCase();
    if (pathnameInLowerCase.startsWith('/fr')) {
        return 'fr-CH';
    }
    if (pathnameInLowerCase.startsWith('/it')) {
        return 'it-CH';
    }
    return 'de-CH';
}
export var getCurrentCulture = function (host, path) {
    var country = getCurrentCountry(host, path);
    switch (country.toUpperCase()) {
        case 'PT':
            return 'pt-PT';
        case 'IE':
            return 'en-IE';
        case 'ES':
            return 'es-ES';
        case 'IN':
            return 'en-IN';
        case 'US':
            return resolveAmericanCulture(path);
        case 'GB':
            return 'en-GB';
        case 'FR':
            return 'fr-FR';
        case 'IT':
            return 'it-IT';
        case 'DE':
            return 'de-DE';
        case 'NL':
            return 'nl-NL';
        case 'DK':
            return 'da-DK';
        case 'SE':
            return 'sv-SE';
        case 'AT':
            return 'de-AT';
        case 'NO':
            return 'nb-NO';
        case 'FI':
            return 'fi-FI';
        case 'BE':
            return resolveBelgiumCulture(path);
        case 'SG':
            return 'en-SG';
        case 'JP':
            return 'ja-JP';
        case 'NZ':
            return 'en-NZ';
        case 'AU':
            return 'en-AU';
        case 'CA':
            return resolveCanadianCulture(path);
        case 'CH':
            return resolveSwissCulture(path);
    }
    throw new Error("Unknown culture for host " + host + " and path " + path);
};
//# sourceMappingURL=data:application/json;base64,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